export const localReference = {
  }